export var LinkAttributeValue;

(function (LinkAttributeValue) {
  LinkAttributeValue["RelNoFollow"] = "nofollow";
  LinkAttributeValue["TargetBlank"] = "_blank";
})(LinkAttributeValue || (LinkAttributeValue = {}));